// UI gates for org-owned capabilities. Convenience only: every service
// enforces the same rules server-side (models/<service>/capabilities.py),
// so a surface that forgets to gate still fails safely with a 403 the
// capabilityErrors helper renders. Tolerates a missing AuthProvider (tests,
// public pages) by treating everything as allowed.
import { useAuth } from '../context/AuthContext';
import { deniedMessageFor } from '../utils/capabilityErrors';
import { normalizeModelPolicy } from '../config/capabilities';

export function useCapability(id) {
  const auth = useAuth();
  const caps = auth?.capabilities;
  const allowed = !caps || !id ? true : !caps.denied.has(id);
  return { allowed, loaded: !caps || !!caps.loaded, message: allowed ? null : deniedMessageFor(id) };
}

export function useModelPolicy() {
  const auth = useAuth();
  return normalizeModelPolicy(auth?.capabilities?.modelPolicy);
}

/** Scope for src/utils/dftJobLookup.js: org-wide when the member holds jobs.view.org. */
export function useJobLookupScope() {
  const auth = useAuth();
  const { allowed } = useCapability('jobs.view.org');
  const orgId = auth?.orgMember?.orgId || null;
  return { orgId, viewOrg: !!(allowed && orgId) };
}

export default useCapability;
